export const mapSourceIds = {
    orders: 'orders-map-orders',
    venue: 'orders-map-venue',
} as const

export const mapLayerIds = {
    orderClusters: 'orders-map-clusters',
    orderClusterCount: 'orders-map-cluster-count',
    orderPins: 'orders-map-order-pins',
    venuePin: 'orders-map-venue-pin',
} as const

export const mapClusterRadius = 50
